(function () {
  var MAX_ITEMS = 5;
  var lastKnownCount = null;
  var fetchTimer = null;

  function pluralize(count) {
    return count + ' garment' + (count === 1 ? '' : 's');
  }

  function messageFor(count) {
    if (count < 3) {
      var firstRemaining = 3 - count;
      return 'Add ' + firstRemaining + ' more item' + (firstRemaining === 1 ? '' : 's') + ' for Buy 2, Get 1 Free';
    }

    if (count < 5) {
      var secondRemaining = 5 - count;
      return 'Add ' + secondRemaining + ' more item' + (secondRemaining === 1 ? '' : 's') + ' for Buy 3, Get 2 Free';
    }

    return 'Buy 3, Get 2 Free unlocked!';
  }

  function celebrate(milestone, threshold) {
    var confetti = document.createElement('span');
    var colors = ['#ef3b4c', '#ff9eb2', '#f7c948', '#57c5b6', '#8d6ccf'];
    confetti.className = 'anniversary-confetti anniversary-confetti--' + threshold;
    confetti.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 34; index += 1) {
      var piece = document.createElement('i');
      piece.style.setProperty('--confetti-x', ((Math.random() * 180) - 90) + 'px');
      piece.style.setProperty('--confetti-y', (-((Math.random() * 70) + 45)) + 'px');
      piece.style.setProperty('--confetti-r', ((Math.random() * 540) - 270) + 'deg');
      piece.style.setProperty('--confetti-delay', (Math.random() * .18) + 's');
      piece.style.backgroundColor = colors[index % colors.length];
      confetti.appendChild(piece);
    }

    milestone.appendChild(confetti);
    window.setTimeout(function () { confetti.remove(); }, 1400);
  }

  function updateMilestones(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    var count = cart.items.reduce(function (total, item) {
      var productType = (item.product_type || '').toLowerCase();
      var isGarment = productType === 'shorts set' || productType === 'pajama set';
      return total + (isGarment ? item.quantity : 0);
    }, 0);
    var cappedCount = Math.min(count, MAX_ITEMS);
    var progress = Math.max(0, Math.min(83.333, cappedCount * 16.6666));

    document.querySelectorAll('[data-anniversary-milestone]').forEach(function (milestone) {
      [1, 3, 5].forEach(function (threshold) {
        if (lastKnownCount !== null && lastKnownCount < threshold && count >= threshold) {
          celebrate(milestone, threshold);
        }
      });

      milestone.dataset.itemCount = count;

      var countElement = milestone.querySelector('[data-anniversary-count]');
      var messageElement = milestone.querySelector('[data-anniversary-message]');
      var shippingElement = milestone.querySelector('[data-anniversary-shipping]');
      var progressElement = milestone.querySelector('[data-anniversary-progress]');
      var fillElement = milestone.querySelector('[data-anniversary-progress-fill]');

      if (countElement) countElement.textContent = pluralize(count);
      if (messageElement) messageElement.textContent = messageFor(count);
      if (shippingElement) shippingElement.textContent = count >= 1 ? 'Unlocked' : 'On first item';
      if (progressElement) progressElement.setAttribute('aria-valuenow', cappedCount);
      if (fillElement) fillElement.style.width = progress + '%';

      milestone.querySelectorAll('[data-anniversary-marker]').forEach(function (marker) {
        marker.classList.toggle('is-reached', count >= Number(marker.dataset.anniversaryMarker));
      });
    });

    lastKnownCount = count;
  }

  function fetchCart() {
    return fetch(window.theme && theme.routes ? theme.routes.cart : '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(updateMilestones)
      .catch(function () {});
  }

  function scheduleCartFetch(delay) {
    window.clearTimeout(fetchTimer);
    fetchTimer = window.setTimeout(fetchCart, delay || 450);
  }

  document.addEventListener('DOMContentLoaded', fetchCart);
  document.addEventListener('cart:build', fetchCart);
  document.addEventListener('ajaxProduct:added', fetchCart);
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      updateMilestones(event.detail.cart);
    } else {
      fetchCart();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('.remove-item')) {
      scheduleCartFetch(650);
    }

    if (event.target.closest('.js-qty__adjust')) {
      scheduleCartFetch(700);
    }
  });
})();
